// @ts-nocheck
import { useState } from "react";
import { useListMessages, useListDevices } from "../lib/api-client-react";
import { PageHeader } from "../components/layout/PageHeader";
import { StatCard } from "../components/StatCard";
import { useLang } from "../lib/lang";

const STATUS_KEYS = ["all", "pending", "sent", "delivered", "failed", "read"] as const;

const statusStyle = (status: string) => {
  const map: Record<string, string> = {
    delivered: "bg-[#d4edda] text-[#155724]",
    sent: "bg-[#cce5ff] text-[#004085]",
    pending: "bg-[#fff3cd] text-[#856404]",
    failed: "bg-[#f8d7da] text-[#721c24]",
    read: "bg-[#e2d9f3] text-[#6f42c1]",
  };
  return map[status] ?? "bg-[#e9ecef] text-[#525f7f]";
};

export function Messages() {
  const { t } = useLang();
  const d = t.messages;

  const { data: messages, isLoading } = useListMessages();
  const { data: devices } = useListDevices();
  const [activeTab, setActiveTab] = useState("all");

  const filtered = (messages ?? []).filter(m => activeTab === "all" || m.status === activeTab);
  const counts = STATUS_KEYS.reduce((acc, s) => {
    acc[s] = s === "all" ? (messages?.length ?? 0) : (messages?.filter(m => m.status === s).length ?? 0);
    return acc;
  }, {} as Record<string, number>);

  const getDeviceName = (id: number) => devices?.find(dv => dv.id === id)?.name ?? `Device #${id}`;

  return (
    <div>
      <PageHeader title={d.title} />

      <div className="px-6 pb-6 space-y-6">
        <div className="grid grid-cols-4 gap-4">
          <StatCard label={d.totalMessages} value={messages?.length ?? 0} iconClass="fas fa-list-ul" gradient="primary" />
          <StatCard label={d.delivered} value={counts.delivered ?? 0} iconClass="fas fa-check-double" gradient="success" />
          <StatCard label={d.pending} value={counts.pending ?? 0} iconClass="fas fa-clock" gradient="warning" />
          <StatCard label={d.failed} value={counts.failed ?? 0} iconClass="fas fa-times-circle" gradient="danger" />
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-[#e9ecef]">
          <div className="px-5 pt-4 border-b border-[#e9ecef]">
            <div className="flex items-center gap-0 overflow-x-auto">
              {STATUS_KEYS.map(tab => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap -mb-px ${activeTab === tab ? "border-[#1171ef] text-[#1171ef]" : "border-transparent text-[#8898aa] hover:text-[#525f7f]"}`}
                >
                  {d.tabs[tab]} <span className="ms-1 text-xs bg-[#e9ecef] px-1.5 py-0.5 rounded-full text-[#525f7f]">{counts[tab]}</span>
                </button>
              ))}
            </div>
          </div>

          {isLoading ? (
            <div className="p-8 text-center text-[#8898aa]"><i className="fas fa-spinner fa-spin text-2xl" /></div>
          ) : filtered.length === 0 ? (
            <div className="p-12 text-center">
              <i className="fas fa-inbox text-4xl text-[#cad1d7] mb-3 block" />
              <p className="text-[#8898aa] text-sm">{d.noMessages}</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr>
                    <th className="px-5 py-3 text-start text-xs font-semibold text-[#8898aa] uppercase tracking-wider">{d.recipient}</th>
                    <th className="px-5 py-3 text-start text-xs font-semibold text-[#8898aa] uppercase tracking-wider">{d.device}</th>
                    <th className="px-5 py-3 text-start text-xs font-semibold text-[#8898aa] uppercase tracking-wider">{d.content}</th>
                    <th className="px-5 py-3 text-start text-xs font-semibold text-[#8898aa] uppercase tracking-wider">{t.common.status}</th>
                    <th className="px-5 py-3 text-start text-xs font-semibold text-[#8898aa] uppercase tracking-wider">{t.common.date}</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map(m => (
                    <tr key={m.id} className="border-t border-[#f6f9fc] hover:bg-[#f8f9fe]">
                      <td className="px-5 py-3 text-sm font-medium text-[#32325d]">{m.phone}</td>
                      <td className="px-5 py-3 text-sm text-[#525f7f]">{getDeviceName(m.deviceId)}</td>
                      <td className="px-5 py-3 text-sm text-[#525f7f] max-w-[200px] truncate">{m.content}</td>
                      <td className="px-5 py-3">
                        <span className={`text-xs font-medium px-2.5 py-0.5 rounded-full ${statusStyle(m.status)}`}>
                          {(d.tabs as any)[m.status] ?? m.status}
                        </span>
                      </td>
                      <td className="px-5 py-3 text-xs text-[#8898aa]">{m.sentAt ? new Date(m.sentAt).toLocaleString() : "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
